import { render, staticRenderFns } from "./ReportUserCustomer.vue?vue&type=template&id=0b0c6fb1"
import script from "./ReportUserCustomer.vue?vue&type=script&lang=js"
export * from "./ReportUserCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports